export interface DialogInstance {

    shouldHideOverlay(): void;
    shouldRestoreHideOverlay(): void;

}

class DialogStack {

    private stack: DialogInstance[] = [];

    registerDialog(dialog: DialogInstance) {
        for (const currentStackItem of this.stack) {
            currentStackItem.shouldHideOverlay();
        }
        this.stack.push(dialog);
    }

    unregisterDialog(dialog: DialogInstance) {
        const dialogInstanceIdx = this.stack.indexOf(dialog);
        if (dialogInstanceIdx >= 0) {
            this.stack.splice(dialogInstanceIdx, 1);
            if (this.stack.length) {
                const mostUpperItem = this.stack[this.stack.length - 1];
                mostUpperItem.shouldRestoreHideOverlay();
            }
        }
    }

}

const DIALOG_STACK_INSTANCE = new DialogStack();

export {DIALOG_STACK_INSTANCE};
